import React from "react";
import { Dropdown } from "react-bootstrap";
import { Box, Stack, Typography } from "@mui/material";

export function ManageCouplesToolbar({
  total,
  searchKey,
  onSearch,
  isAdmin,
  onDownloadSample,
  onImportClick,
  onFileChange,
  onExportExcel,
  onExportPdf,
}: {
  total: number;
  searchKey: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAdmin: boolean;
  onDownloadSample: () => void;
  onImportClick: () => void;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onExportExcel: () => void;
  onExportPdf: () => void;
}) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      useFlexGap
      sx={{ mb: 1.5, width: "100%", minWidth: 0 }}
    >
      <Typography
        className="card-title card_head"
        sx={{ m: 0, flex: "0 0 auto", fontSize: { xs: "1.05rem", sm: "1.25rem" } }}
      >
        Couples: {total}
      </Typography>
      <Box
        className="form-group content1"
        sx={{ flex: "1 1 220px", minWidth: 0, maxWidth: { sm: 360 }, mb: "0 !important" }}
      >
        <div className="input-group setSearch">
          <input
            onChange={onSearch}
            type="text"
            className="form-control searchData"
            placeholder="Search..."
            aria-label="Search couples"
            value={searchKey}
          />
          <div className="input-group-append">
            <button className="btn btn-sm btn-primary" type="button">
              <i className="icon-search"></i>
            </button>
          </div>
        </div>
      </Box>
      {isAdmin ? (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          className="import_buttons content1"
          sx={{ flex: "0 1 auto", justifyContent: { xs: "flex-start", md: "flex-end" } }}
        >
          <a onClick={onDownloadSample} className="btn me-0 set_text1">
            (Download Sample Excel)
          </a>
          <div className="import_drop d-inline-flex align-items-center">
            <a
              onClick={onImportClick}
              className="btn btn-outline-primary btn-sm impbtn import_button d-inline-flex align-items-center me-2"
              style={{ height: "34px" }}
            >
              <i className="icon-upload me-1"></i> Import
            </a>
            <input
              className="btn btn-secondary"
              type="file"
              name="File Upload"
              id="fileUpload"
              hidden
              onChange={onFileChange}
              accept=".xlsx"
            />
            <Dropdown className="dropset d-inline-flex align-items-center">
              <Dropdown.Toggle
                className="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                id="dropdown-basic"
                style={{ height: "34px" }}
              >
                <i className="icon-download me-1"></i>
                Export
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={onExportExcel}>Excel</Dropdown.Item>
                <Dropdown.Item onClick={onExportPdf}>PDF</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Stack>
      ) : null}
    </Stack>
  );
}
